import { render, staticRenderFns } from "./RejectReasonDetail.vue?vue&type=template&id=7fbe0e88&scoped=true"
import script from "./RejectReasonDetail.vue?vue&type=script&lang=js"
export * from "./RejectReasonDetail.vue?vue&type=script&lang=js"
import style0 from "./RejectReasonDetail.vue?vue&type=style&index=0&id=7fbe0e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbe0e88",
  null
  
)

export default component.exports